(function () {
	"use strict";

	const TAB_SELECTOR = "[data-tug-tab]";
	const PANEL_SELECTOR = "[data-tug-panel]";
	const HASH_PREFIX = "#guide-";

	function formatFromHash() {
		const hash = window.location.hash.toLowerCase();
		if (!hash.startsWith(HASH_PREFIX)) return "";
		return hash.slice(HASH_PREFIX.length);
	}

	function rememberFormat(format) {
		if (!window.history || !window.history.replaceState) return;
		window.history.replaceState(null, "", HASH_PREFIX + format);
	}

	function activateFormat(root, format, shouldFocus) {
		const tabs = Array.from(root.querySelectorAll(TAB_SELECTOR));
		const panels = Array.from(root.querySelectorAll(PANEL_SELECTOR));
		const nextTab = tabs.find(function (tab) {
			return tab.dataset.tugTab === format;
		});

		if (!nextTab) return;

		tabs.forEach(function (tab) {
			const isActive = tab === nextTab;
			tab.setAttribute("aria-selected", String(isActive));
			tab.tabIndex = isActive ? 0 : -1;
		});

		panels.forEach(function (panel) {
			panel.hidden = panel.dataset.tugPanel !== format;
		});

		root.dataset.tugActive = format;
		if (shouldFocus) nextTab.focus();
	}

	function setupGuide(root) {
		if (!root || root.dataset.tugBound === "true") return;
		root.dataset.tugBound = "true";
		root.classList.add("is-enhanced");

		const tabs = Array.from(root.querySelectorAll(TAB_SELECTOR));
		if (!tabs.length) return;

		const requestedFormat =
			formatFromHash() || new URLSearchParams(window.location.search).get("format");
		const requestedTab = tabs.find(function (tab) {
			return tab.dataset.tugTab === requestedFormat;
		});
		const selectedTab = tabs.find(function (tab) {
			return tab.getAttribute("aria-selected") === "true";
		});
		const initialTab = requestedTab || selectedTab || tabs[0];

		activateFormat(root, initialTab.dataset.tugTab, false);

		tabs.forEach(function (tab, index) {
			tab.addEventListener("click", function () {
				activateFormat(root, tab.dataset.tugTab, false);
				rememberFormat(tab.dataset.tugTab);
			});

			tab.addEventListener("keydown", function (event) {
				let nextIndex = index;

				if (event.key === "ArrowRight" || event.key === "ArrowDown") {
					nextIndex = (index + 1) % tabs.length;
				} else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
					nextIndex = (index - 1 + tabs.length) % tabs.length;
				} else if (event.key === "Home") {
					nextIndex = 0;
				} else if (event.key === "End") {
					nextIndex = tabs.length - 1;
				} else {
					return;
				}

				event.preventDefault();
				activateFormat(root, tabs[nextIndex].dataset.tugTab, true);
				rememberFormat(tabs[nextIndex].dataset.tugTab);
			});
		});

		window.addEventListener("hashchange", function () {
			const format = formatFromHash();
			if (format) activateFormat(root, format, false);
		});
	}

	function init() {
		document.querySelectorAll("[data-tug-root]").forEach(setupGuide);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init, { once: true });
	} else {
		init();
	}
})();
